import Header from 'components/headers/bulletins'
import ManageCardIcon from 'assets/images/settingFund/manage-card.svg'
import Switch from 'react-switch'
import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import useGetMoneyPoolManagement from 'pages/fund/fundPage/hooks/useGetMoneyPoolManagement'
import BuyPlanModal from 'components/modals/BuyPlan'
import MyWalletModals from 'components/modals/myWallets'
import useEditInfo from '../info/body/hooks/useEditInfo'
import useSetManageSetting from './hooks/useSetManageSetting'
import { toast } from 'react-toastify'

export default function ManageSetting() {
    const { id } = useParams()
    const navigate = useNavigate()
    const [isOpen, setIsOpen] = useState<boolean>(false)
    const [isOpenCard, setIsOpenCard] = useState<boolean>(false)
    const { moneyPoolManagement, isLoadingMoneypoolManagement, refetch } =
        useGetMoneyPoolManagement(id)
    const [value1, setValue1] = useState<boolean>(
        moneyPoolManagement && moneyPoolManagement.trust_state === 'trst'
            ? false
            : true
    )
    const [value2, setValue2] = useState<boolean>(
        moneyPoolManagement && moneyPoolManagement.type === 'mt_hbrd'
            ? true
            : false
    )
    const [value3, setValue3] = useState<boolean>(
        moneyPoolManagement && moneyPoolManagement.sms_announce === 'all'
            ? true
            : false
    )
    const [selectedCard, setSelectedCard] = useState<undefined | IBankAccount>(
        undefined
    )

    useEffect(() => {
        if (moneyPoolManagement?.bank_account) {
            setSelectedCard(moneyPoolManagement.bank_account)
        }
    })

    useEffect(() => {
        setValue1(
            moneyPoolManagement && moneyPoolManagement.trust_state === 'trst'
                ? false
                : true
        )
        setValue2(
            moneyPoolManagement && moneyPoolManagement.type === 'mt_hbrd'
                ? true
                : false
        )
        setValue3(
            moneyPoolManagement && moneyPoolManagement.sms_announce === 'all'
                ? true
                : false
        )
    }, [moneyPoolManagement])
    const { mutate } = useSetManageSetting(refetch)

    return (
        <div className=" flex flex-col h-screen">
            <div className=" grow-0">
                <Header title="تنظیمات صندوق" />
            </div>
            <div className=" px-3 grow">
                <div className=" flex my-4">
                    <img src={ManageCardIcon} alt="manage" />
                    <p className=" mx-2">مدیریت حساب</p>
                </div>
                <hr />
                <div className=" w-full flex justify-between items-center my-4">
                    <p className="">اتصال صندوق به حساب مدیر</p>
                    <Switch
                        onChange={() => {
                            if (value1) {
                                toast.error(
                                    'جهت لغو اتصال حساب بانکی با پشتیبانی ارتباط بگیرید'
                                )
                            } else {
                                if (
                                    moneyPoolManagement &&
                                    moneyPoolManagement.service_package === 2
                                ) {
                                    setIsOpen(true)
                                } else {
                                    setValue1(!value1)
                                }
                            }
                        }}
                        checked={value1}
                        onColor="#75B844"
                        onHandleColor="#EAEEF0"
                        handleDiameter={25}
                        uncheckedIcon={false}
                        checkedIcon={false}
                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        activeBoxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        height={30}
                        width={60}
                        className="react-switch"
                        id="material-switch"
                        offColor="#B6BCC8"
                    />
                </div>
                {value1 ? (
                    <div
                        className=" w-full py-2 border-1 border-gray-6 text-center text-gray-2 rounded-lg"
                        onClick={() => setIsOpenCard(true)}
                    >
                        {selectedCard
                            ? `${selectedCard.full_name} - ${selectedCard.bank_name}`
                            : 'انتخاب حساب'}
                    </div>
                ) : (
                    <p className=" my-3 text-gray-3 text-sm">
                        با فعال کردن این گزینه تمامی پرداختی های اعضا به حساب
                        مدیر براساس سیکل تسویه واریز می شود.
                    </p>
                )}
                <hr className=" my-3" />
                <div className=" w-full flex justify-between items-center my-4">
                    <p className="">
                        امکان پرداخت از طریق درگاه برای تمامی اعضا
                    </p>
                    <Switch
                        onChange={() => {
                            if (
                                moneyPoolManagement &&
                                moneyPoolManagement.service_package === 2
                            ) {
                                setIsOpen(true)
                            } else {
                                setValue2(!value2)
                            }
                        }}
                        checked={value2}
                        onColor="#75B844"
                        onHandleColor="#EAEEF0"
                        handleDiameter={25}
                        uncheckedIcon={false}
                        checkedIcon={false}
                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        activeBoxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        height={30}
                        width={60}
                        className="react-switch"
                        id="material-switch"
                        offColor="#B6BCC8"
                    />
                </div>
                <p className=" my-3 text-gray-3 text-sm">
                    با فعال کردن این گزینه تمامی اعضای صندوق امکان پرداخت درون
                    برنامه ای را خواهند داشت.
                </p>
                <hr className=" my-3" />
                <div className=" w-full flex justify-between items-center my-4">
                    <p className="">ارسال پیامک به تمام اعضا</p>
                    <Switch
                        onChange={() => {
                            if (
                                moneyPoolManagement &&
                                moneyPoolManagement.service_package === 2
                            ) {
                                setIsOpen(true)
                            } else {
                                setValue3(!value3)
                            }
                        }}
                        checked={value3}
                        onColor="#75B844"
                        onHandleColor="#EAEEF0"
                        handleDiameter={25}
                        uncheckedIcon={false}
                        checkedIcon={false}
                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        activeBoxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        height={30}
                        width={60}
                        className="react-switch"
                        id="material-switch"
                        offColor="#B6BCC8"
                    />
                </div>
                <p className=" my-3 text-gray-3 text-sm">
                    با غیرفعال کردن این گزینه، اعضای صندوق هیچ پیامکی از نوع
                    یادآوری، اطلاع رسانی و ... دریافت نخواهند کرد.
                </p>
                <hr className=" my-3" />
            </div>
            <div className=" grow-0 px-2">
                <button
                    className=" w-full bg-green-1 text-white rounded-lg py-3 mb-2"
                    onClick={() => {
                        if (moneyPoolManagement) {
                            const payload: ISettingManagePayload = {
                                name: moneyPoolManagement.name,
                                bankBalance: Number(
                                    moneyPoolManagement.bank_balance
                                ),
                                interval: moneyPoolManagement.interval,
                                shareValue:
                                    moneyPoolManagement.share_value_amount,
                                dayOfDuetion:
                                    moneyPoolManagement.day_of_duetion,
                                type: value2 ? 'mt_hbrd' : 'mt_hbrd_sp',
                                notificationAnnounce:
                                    moneyPoolManagement.notification_announce,
                                smsAnnounce: moneyPoolManagement.sms_announce,
                                imageId: moneyPoolManagement.image_id,
                                id,
                                bankAccount: Number(selectedCard?.id),
                                trustState: value1 === false ? 'trst' : 'wdvf',
                            }
                            mutate(payload)
                            navigate(-1)
                        }
                    }}
                >
                    ثبت تغییرات
                </button>
            </div>
            <BuyPlanModal show={isOpen} onHide={() => setIsOpen(false)} />
        </div>
    )
}
